/**
 * @author https://github.com/react-hookz/web/blob/c545ce7c9125c920cb5d48ad982dee4d11a006b6/src/useSyncedRef/index.ts
 */
import { useMemo, useRef } from 'react';
/**
 * Like `useRef`, but it returns immutable ref that contains actual value.
 * @param value
 */
export const useSyncedRef = (value) => {
    const ref = useRef(value);
    ref.current = value;
    return useMemo(() => Object.freeze({
        get current() {
            return ref.current;
        },
    }), []);
};
//# sourceMappingURL=useSyncedRef.js.map